function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".dots-after_svg__cls-3{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "dots-after_svg__Warstwa_2",
  "data-name": "Warstwa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "dots-after_svg__Tryb_izolacji",
  "data-name": "Tryb izolacji"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5.4,
  cy: 5.4,
  r: 5.4,
  fill: "#fdc300"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 111.9,
  cy: 5.8,
  r: 3,
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("circle", {
  className: "dots-after_svg__cls-3",
  cx: 104.6,
  cy: 6.1,
  r: 0.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "dots-after_svg__cls-3",
  cx: 97.4,
  cy: 6.1,
  r: 0.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "dots-after_svg__cls-3",
  cx: 90.1,
  cy: 6.1,
  r: 0.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "dots-after_svg__cls-3",
  cx: 119.1,
  cy: 6.1,
  r: 0.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "dots-after_svg__cls-3",
  cx: 126.3,
  cy: 6.1,
  r: 0.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "dots-after_svg__cls-3",
  cx: 82.9,
  cy: 6.1,
  r: 0.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "dots-after_svg__cls-3",
  cx: 75.7,
  cy: 6.1,
  r: 0.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "dots-after_svg__cls-3",
  cx: 68.4,
  cy: 6.1,
  r: 0.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "dots-after_svg__cls-3",
  cx: 61.2,
  cy: 6.1,
  r: 0.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "dots-after_svg__cls-3",
  cx: 53.9,
  cy: 6.1,
  r: 0.9
})));

function SvgDotsAfter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 127.2 10.8"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjcuMiAxMC44Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZkYzMwMDt9LmNscy0ye2ZpbGw6I2UzMDYxMzt9LmNscy0ze2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPlphc2/MgWIgNTwvdGl0bGU+PGcgaWQ9IldhcnN0d2FfMiIgZGF0YS1uYW1lPSJXYXJzdHdhIDIiPjxnIGlkPSJUcnliX2l6b2xhY2ppIiBkYXRhLW5hbWU9IlRyeWIgaXpvbGFjamkiPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iNS40IiBjeT0iNS40IiByPSI1LjQiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMiIgY3g9IjExMS45IiBjeT0iNS44IiByPSIzIi8+PGNpcmNsZSBjbGFzcz0iY2xzLTMiIGN4PSIxMDQuNiIgY3k9IjYuMSIgcj0iMC45Ii8+PGNpcmNsZSBjbGFzcz0iY2xzLTMiIGN4PSI5Ny40IiBjeT0iNi4xIiByPSIwLjkiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMyIgY3g9IjkwLjEiIGN5PSI2LjEiIHI9IjAuOSIvPjxjaXJjbGUgY2xhc3M9ImNscy0zIiBjeD0iMTE5LjEiIGN5PSI2LjEiIHI9IjAuOSIvPjxjaXJjbGUgY2xhc3M9ImNscy0zIiBjeD0iMTI2LjMiIGN5PSI2LjEiIHI9IjAuOSIvPjxjaXJjbGUgY2xhc3M9ImNscy0zIiBjeD0iODIuOSIgY3k9IjYuMSIgcj0iMC45Ii8+PGNpcmNsZSBjbGFzcz0iY2xzLTMiIGN4PSI3NS43IiBjeT0iNi4xIiByPSIwLjkiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMyIgY3g9IjY4LjQiIGN5PSI2LjEiIHI9IjAuOSIvPjxjaXJjbGUgY2xhc3M9ImNscy0zIiBjeD0iNjEuMiIgY3k9IjYuMSIgcj0iMC45Ii8+PGNpcmNsZSBjbGFzcz0iY2xzLTMiIGN4PSI1My45IiBjeT0iNi4xIiByPSIwLjkiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgDotsAfter as ReactComponent };